const SituacaoBmpOrigem = {
  Pendente: 1,
  Aprovado: 2,
  PendenteMesa: 3,
  Negado: 4,
  AguardandoBureau: 5
}

const RESTRICAO_BUREAU = 3
const COMPARATIVO_NAO_CONFORME = 2
const CAMPOS_SITUACAO_BUREAU = [
  'situacaoDataBusca',
  'situacaoObitoFiscal',
  'situacaoCadastroRestritivo',
  'situacaoMidiaDesabonadora',
  'situacaoEmailAge',
  'situacaoCriminalResumo',
  'situacaoCriminalDetalhe',
  'situacaoQuodRufra',
  'situacaoSerproReceita',
  'situacaoDictMed'
]

function comparativoIncompativel(comparativoDados) {
  return Array.isArray(comparativoDados)
    && comparativoDados.some(item => item.comparativoBureau === COMPARATIVO_NAO_CONFORME)
}

function possuiReprovacaoBureaus(onboarding) {
  return CAMPOS_SITUACAO_BUREAU.some(campo => onboarding && onboarding[campo] === RESTRICAO_BUREAU)
}

export default {
  ObterDecisaoAnalise(situacaoBmpOrigem, onboarding, comparativoDados) {
    const possuiReprovacao = possuiReprovacaoBureaus(onboarding) || comparativoIncompativel(comparativoDados)

    if (situacaoBmpOrigem === null || situacaoBmpOrigem === undefined)
      return possuiReprovacao ? 'Reprovado' : 'Aprovado'

    if (situacaoBmpOrigem === SituacaoBmpOrigem.Aprovado)
      return 'Aprovado'

    if (situacaoBmpOrigem === SituacaoBmpOrigem.Negado || possuiReprovacao)
      return 'Reprovado'

    if (situacaoBmpOrigem === SituacaoBmpOrigem.PendenteMesa)
      return 'Pendente de Mesa'

    return 'Pendente'
  },
  FormatCNH(value) {
    if (!value) {
      return ''
    }
    value = value.toString().toUpperCase()
    const regex = /([0-9A-Z]{1})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{3})([0-9A-Z]{1})/
    const subst = '$1 $2 $3 $4 $5'
    return value.replace(regex, subst)
  },
  FormatRNE(value) {
    if (!value) {
      return ''
    }
    value = value.toString().toUpperCase()
    const regex = /([A-Z]{1})([0-9]{6})([0-9A-Z]{1})/
    const subst = '$1$2-$3'
    return value.replace(regex, subst)
  },
  ObterTipoArquivo(fileName) {
    const lastDotIndex = fileName.lastIndexOf('.');

    if (lastDotIndex === -1) {
      return null;
    }

    const extension = fileName.slice(lastDotIndex + 1).toLowerCase();
 
    switch (extension) {
      case 'png':
        return 'image/png'
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg'
      case 'pdf':
        return 'application/pdf'
      default:
        return null
    }
  },
  AjustarSituacaoOnboardingConta(response) {
    const situacaoAguardandoAnalisePendenciado = 8
    const situacaoAguardandoAnaliseOnboarding = 6

    const situacaoAguardandoAnaliseRecusada = 7
    const situacaoAguardandoAnaliseCancelada = 5

    const situacaoPendenteProcessamentoOrigem = 13
    const situacaoPendenteAnaliseManualOrigem = 14
    const situacaoReprovadoOrigem = 15

    for (let count = 0; response.length > count; count++) {
      if (response[count].situacaoSolicitacaoConta == situacaoAguardandoAnalisePendenciado) {
        response[count].situacao = situacaoAguardandoAnaliseOnboarding
        continue
      }

      if (response[count].situacaoSolicitacaoConta ==  situacaoAguardandoAnaliseRecusada) {
        response[count].situacao = situacaoAguardandoAnaliseCancelada
        continue
      }

      if (response[count].situacaoSolicitacaoConta ==  situacaoAguardandoAnaliseCancelada) {
        response[count].situacao = situacaoAguardandoAnaliseRecusada
        continue
      }

      if (response[count].situacaoSolicitacaoConta == situacaoPendenteProcessamentoOrigem ||
          response[count].situacaoSolicitacaoConta == situacaoPendenteAnaliseManualOrigem ||
          response[count].situacaoSolicitacaoConta == situacaoReprovadoOrigem) {
        response[count].situacao = response[count].situacaoSolicitacaoConta
        continue
      }
    }

    return response
  },
  FormatarDataHora(dataIso) {
    if (!dataIso) return "";

    const data = new Date(dataIso);

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();

    const horas = String(data.getHours()).padStart(2, '0');
    const minutos = String(data.getMinutes()).padStart(2, '0');
    const segundos = String(data.getSeconds()).padStart(2, '0');

    return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
  }
}
